module.exports = __webpack_public_path__ + "static/media/carousel-05.ed376d89.jpg";